import { createAction, props } from '@ngrx/store';
import { CurrentOnboarding } from '../../generated/auth/models/Sasfin/Wealth/Online/BL/Models/Onboarding/current-onboarding';
import { STORE_TYPE } from './onboarding-info.model';

export const storeName = 'Onboarding Info';

export const loadOnboardingInfoList = createAction(`[${STORE_TYPE}] Load ${storeName} list`);
export const loadOnboardingInfoListSuccess = createAction(
  `[${STORE_TYPE}] Load ${storeName} list (Success)`,
  props<{ payload: CurrentOnboarding[] }>(),
);
export const loadOnboardingInfoListFailure = createAction(
  `[${STORE_TYPE}] Load ${storeName} list (Failure)`,
  props<{ error: any }>(),
);
export const toggleLoadingStatus = createAction(
  `[${STORE_TYPE}] Change loading status for ${storeName} list`,
  props<{ status: boolean }>(),
);

// Select an onboarding info entry from existing list by id
export const selectOnboardingInfoById = createAction(
  `[${STORE_TYPE}] Select ${storeName} by id`,
  props<{ id: number }>(),
);

// Set current onboarding ID
export const setCurrentOnboardingId = createAction(`[${STORE_TYPE}] Set ${storeName} id`, props<{ id: number }>());

// Directly set selected onboarding info (useful when loading metadata independently)
export const setSelectedOnboardingInfo = createAction(
  `[${STORE_TYPE}] Set selected ${storeName}`,
  props<{ payload: CurrentOnboarding | null }>(),
);
